export default "__VITE_ASSET__BlMk38FB__"